"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backgroundColorThemes = exports.backgroundColor = void 0;
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const defaultColor = "blue";
const backgroundColorThemes = (0, _sdsThemeInternal.themed)({
  berry: (0, _designTokensReact.color)("color--background--spectrum-pink--default"),
  berryLight: (0, _designTokensReact.color)("color--background--spectrum-pink--weak"),
  blue: (0, _designTokensReact.color)("color--background--spectrum-blue--default"),
  blueLight: (0, _designTokensReact.color)("color--background--spectrum-blue--weak"),
  green: (0, _designTokensReact.color)("color--background--spectrum-green--default"),
  greenLight: (0, _designTokensReact.color)("color--background--spectrum-green--weak"),
  orange: (0, _designTokensReact.color)("color--background--spectrum-orange--default"),
  orangeLight: (0, _designTokensReact.color)("color--background--spectrum-orange--weak"),
  purple: (0, _designTokensReact.color)("color--background--spectrum-violet--default"),
  purpleLight: (0, _designTokensReact.color)("color--background--spectrum-violet--weak"),
  red: (0, _designTokensReact.color)("color--background--spectrum-red--default"),
  redLight: (0, _designTokensReact.color)("color--background--spectrum-red--weak"),
  teal: (0, _designTokensReact.color)("color--background--spectrum-teal--default"),
  tealLight: (0, _designTokensReact.color)("color--background--spectrum-teal--weak"),
  yellow: (0, _designTokensReact.color)("color--background--spectrum-yellow--default"),
  yellowLight: (0, _designTokensReact.color)("color--background--spectrum-yellow--weak"),
  success: (0, _designTokensReact.color)("color--background--spectrum-mint--weak"),
  warning: (0, _designTokensReact.color)("color--border--warning--default"),
  error: (0, _designTokensReact.color)("color--background--destructive--weak"),
  info: (0, _designTokensReact.color)("color--background--neutral--default")
});
exports.backgroundColorThemes = backgroundColorThemes;
const backgroundColor = (color, themeMode) => {
  const theme = backgroundColorThemes[color] || backgroundColorThemes[defaultColor];
  return theme(themeMode);
};
exports.backgroundColor = backgroundColor;
//# sourceMappingURL=TagTheme.js.map